import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ComponentCatalogGroup, ComponentService} from '../../services/component.service';
import {MarkdownGroup, MarkdownLoaderService} from '../../services/markdown-loader.service';

@Component({
  selector: 'cc-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  componentGroups = new Map<string, ComponentCatalogGroup>();
  markdownGroups: Map<string, MarkdownGroup>;

  constructor(private readonly componentService: ComponentService, private readonly markdownLoaderService: MarkdownLoaderService) {
  }

  ngOnInit() {
    this.componentGroups = this.componentService.getGroups();
    this.markdownGroups = this.markdownLoaderService.getGroups();
  }
}
